<template>
  <div class="rank-custom-wrapper">
    <DepartmentFilters :default="filters" @update="handleFilters" />

    <div class="card card-inverse card-info text-center" v-if="loading">
      <div class="card-block">
        <blockquote class="card-blockquote">Chargement en cours ...</blockquote>
      </div>
    </div>
    <div class="card text-center" v-else-if="data.length === 0">
      <div class="card-block">
        <blockquote class="card-blockquote">
          Aucune données, appliquer ou modifier les filtres
        </blockquote>
      </div>
    </div>

    <div v-else>
      <Tabs v-model="activeTab">
        <Tab header="Carte">
          <RankLongevityResume :data="mapData" :filters="filters" />
        </Tab>
        <Tab header="Classement">
          <RankLongevityDetails :data="data" :filters="filters" />
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import DepartmentFilters from "@/components/coach-manager/DepartmentFilters";
import RankLongevityResume from "@/components/coach-manager/longevity/RankLongevityResume";
import RankLongevityDetails from "@/components/coach-manager/longevity/RankLongevityDetails";
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import { mapGetters } from "vuex";

export default {
  components: {
    DepartmentFilters,
    RankLongevityResume,
    RankLongevityDetails,
    Tabs,
    Tab,
  },
  data() {
    return {
      loading: false,
      data: [],
      mapData: [],
      activeTab: 0,
      filters: this.defaultFilters(),
    };
  },

  computed: {
    ...mapGetters({
      departments: "getDepartments",
    }),

    zipcodes() {
      return this.departments.map(({ code, name }) => {
        if (code === "all") {
          return { label: name, value: code };
        } else {
          return { label: code + " - " + name, value: code };
        }
      });
    },
  },

  methods: {
    handleFilters(newFilters) {
      this.filters = newFilters;

      this.loadCoachs();
    },

    async loadCoachs() {
      try {
        this.loading = true;

        const { data } = await this.$api.get(`/rank/longevity`, {
          params: {
            departments:
              this.filters.departments &&
              this.filters.departments.map((dpt) => dpt.value),
            zipcodes: this.departments,
          },
        });

        this.data = data[0];
        this.mapData = data[1];
      } catch (e) {
        this.$errorToast("Impossible de charger les données");
      } finally {
        this.loading = false;
      }
    },

    defaultFilters() {
      return {
        department: null,
      };
    },
  },
};
</script>
